// @ts-check

import React from 'react';
import { array, func, object } from 'prop-types';
import USER from '../ts/profileEditorEnum';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

/**
 * @component ContactTypeSelector
 * @param {Object} props
 * @param {ContactType[]} props.values
 * @param {ContactType[]} props.options
 * @param {EditorValidType} props.valid
 * @param {(name:string, payload:any) => void} props.onHandleUser
 * @returns {JSX.Element}
 */
function ContactTypeSelector({ values, options, valid, onHandleUser }) {
	return (
		<Autocomplete
			fullWidth
			multiple
			value={values}
			options={options}
			// @ts-ignore
			getOptionLabel={(option) => (option.Title ? option.Title : '')}
			onChange={(e, newValue) => onHandleUser(USER.CONTACT_TYPES, newValue)}
			renderInput={(params) => (
				<TextField
					{...params}
					variant="outlined"
					label="Contact Types"
					required
					InputLabelProps={{ shrink: true }}
					size="small"
					error={valid.hasErr}
					helperText={valid.msg}
				/>
			)}
		/>
	);
}

ContactTypeSelector.propTypes = {
	values: array,
	options: array,
	valid: object,
	onHandleUser: func,
};

export default ContactTypeSelector;
